import { z } from 'zod';

/** One fetched source. Every content fact must trace to one of these. */
export const SourceRef = z.object({
  id: z.string().regex(/^[a-z0-9_]+$/),
  title: z.string().min(1),
  url: z.string().url(),
  accessed: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
});
export type SourceRef = z.infer<typeof SourceRef>;

/** Money is integer cents, never float dollars (frozen contract). */
export const Cents = z.number().int().nonnegative();

export const Biome = z.enum(['grassland', 'scrub', 'woodland', 'wetland', 'rocky', 'tundra']); // tundra species/capture data landed via content15

export const SOURCED_FACT_KEYS = [
  'taxonomy', 'weight', 'reproduction', 'lifespan', 'social',
  'habitat', 'diet', 'price', 'feed_cost', 'morphs',
] as const;

/** Validates a `sources` map: known fact keys, and every id must exist in references. */
export function checkSourcesMap(
  sources: Record<string, string[]>,
  references: SourceRef[],
  label: string,
  errors: string[],
) {
  const refIds = new Set(references.map((r) => r.id));
  const known = new Set<string>(SOURCED_FACT_KEYS as readonly string[]);
  for (const [fact, ids] of Object.entries(sources)) {
    if (!known.has(fact)) errors.push(`${label}: unknown fact key '${fact}' in sources map`);
    if (!Array.isArray(ids) || ids.length === 0) errors.push(`${label}: fact '${fact}' has no source ids`);
    for (const id of ids) if (!refIds.has(id)) errors.push(`${label}: fact '${fact}' cites unknown source id '${id}'`);
  }
  for (const key of SOURCED_FACT_KEYS) {
    if (!(key in sources)) errors.push(`${label}: missing required sourced fact '${key}'`);
  }
}
